import { render, staticRenderFns } from "./HintBody.vue?vue&type=template&id=88afba8c&scoped=true"
import script from "./HintBody.vue?vue&type=script&lang=js"
export * from "./HintBody.vue?vue&type=script&lang=js"
import style0 from "./HintBody.vue?vue&type=style&index=0&id=88afba8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88afba8c",
  null
  
)

export default component.exports